import styles from "./Test.module.scss";
import cn from "classnames";
import {useMemo} from "react";


export const Test = ({desc, arr, pic, handler, className, children}) => {
    const checkAnswer = (e, index, answer, text) => {
        e.currentTarget.querySelector('span').innerText = `${text}`;
        if (answer) {
            e.currentTarget.classList.add(styles.success);
            handler(true);
        } else {
            e.currentTarget.classList.add(styles.error);
        }
    }

    const answersList = arr.map((item, index) => {
        return <li key={index} className={cn(styles.wrap, styles.littleWrap)} onClick={e => checkAnswer(e, index, item.answer, item.desc)}>
            <div className={styles.answer}>
                <span>{item.name}</span>
            </div>
        </li>
    });

    //eslint-disable-next-line
    const result = useMemo(() => answersList, [arr]);

    return (
        <div className={cn(styles.test, className ? className : "")}>
            <div className={styles.block}>
                <div className={styles.pic}>
                    <img src={pic} alt="2x2"/>
                </div>
                <div className={styles.content}>
                    <div className={styles.wrap}>
                        <div className={styles.question}>
                            <span>{desc}</span>
                        </div>
                    </div>
                    <ul className={styles.list}>
                        {result}
                    </ul>
                </div>
                {children}
            </div>
        </div>
    )
}